import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../../react/features/analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../../react/features/analytics/functions';
import { RAISE_HAND_ENABLED } from '../../../../react/features/base/flags/constants';
import { getFeatureFlag } from '../../../../react/features/base/flags/functions';
import { translate } from '../../../../react/features/base/i18n/functions';
import { IconMicSlash } from '../../../../react/features/base/icons/svg';
import { raiseHand } from '../../../../react/features/base/participants/actions';
import { getLocalParticipant, hasRaisedHand } from '../../../../react/features/base/participants/functions';
import AbstractButton from '../../../../react/features/base/toolbox/components/AbstractButton';
import { iAmVisitor } from '../../../../react/features/visitors/functions';
import logger from './logger';
/**
 * Component that renders a toolbar button for toggling the audio state.
 *
 * @augments AbstractButton
 */
class VisitorMuteButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.raiseHand';
        this.icon = IconMicSlash;
        this.label = 'toolbar.unmute';
        this.tooltip = 'toolbar.unmute';
        this.toggledTooltip = 'toolbar.mute';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _raisedHand, dispatch } = this.props;
        const enable = !_raisedHand;
        sendAnalytics(createToolbarEvent('visitor.mute.hand', { enable }));
        logger.debug(`Visitor mute button: ${enable ? 'enable' : 'disable'}`);
        dispatch(raiseHand(enable));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._raisedHand;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code TileViewButton} component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const _localParticipant = getLocalParticipant(state);
    const visible = getFeatureFlag(state, RAISE_HAND_ENABLED, true) && iAmVisitor(state);
    return {
        _localParticipant,
        _raisedHand: hasRaisedHand(_localParticipant),
        visible
    };
}
export default translate(connect(_mapStateToProps)(VisitorMuteButton));
